import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { IconVideo } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import { toggleSGI } from '../actions';
import { getSgiSession, isLocalParticipantSGIModerator } from '../functions';
/**
 * SGI Button Component.
 *
 * Toggles SGI (Sistema de Gerenciamento de Imagens) sharing on/off.
 * Shows different states based on session status and moderator role.
 */
class SGIButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.sgi_share';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.sgi_stop';
    icon = IconVideo;
    label = 'toolbar.sgi_share';
    toggledLabel = 'toolbar.sgi_stop';
    tooltip = 'toolbar.sgi_share';
    toggledTooltip = 'toolbar.sgi_stop';
    /**
     * Handle button click.
     *
     * @returns {void}
     */
    _handleClick() {
        this.props.dispatch(toggleSGI());
    }
    /**
     * Whether the button shows toggled (active) state.
     *
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isSessionActive;
    }
    /**
     * Whether the button is disabled
     * Disabled when session is active but user is not the moderator.
     *
     * @returns {boolean}
     */
    _isDisabled() {
        return this.props._isDisabled;
    }
}
/**
 * Maps Redux state to component props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function _mapStateToProps(state) {
    const session = getSgiSession(state);
    const isModerator = isLocalParticipantSGIModerator(state);
    const isSessionActive = session?.active ?? false;
    return {
        _isDisabled: isSessionActive && !isModerator,
        _isModerator: isModerator,
        _isSessionActive: isSessionActive,
        _moderatorName: session?.moderatorName ?? null
    };
}
export default translate(connect(_mapStateToProps)(SGIButton));
